import React from 'react'
import PropTypes from 'prop-types'
import './Card.less'

export default function Card({ children, className = '', variant = 'default' }) {
  return (
    <div className={['inicio-card', `inicio-card--${variant}`, className].filter(Boolean).join(' ')}>
      {children}
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'hero', 'assistant'])
}
